import jwt from '../../http/requests/auth/jwt/index.js';
import 'firebase/auth';
import axios from '@/axios';

export default {
  fetchProducts(_context, data) {
    return new Promise((resolve, reject) => {
        jwt
        .fetchHttpProduct(data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  fetchProductsWithDrugBookEnabled(_context, data) {
    const payload = {
      ...data,
      onlyDrugBookEnabled: true,
    };
    return new Promise((resolve, reject) => {
        jwt
        .fetchHttpProduct(payload)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  fetchOversightProducts(_context, data) {
    return new Promise((resolve, reject) => {
        jwt
        .fetchHttpOversightProduct(data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  fetchClinicOversightProducts(_context, data) {
    return new Promise((resolve, reject) => {
        jwt
        .fetchHttpClinicOversightProduct(data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  fetchBrands() {
    return new Promise((resolve, reject) => {
        jwt
        .fetchBrands()
        .then(res => {
          return resolve(res.data.data);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  fetchProductApplicableAreas(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .fetchHttpApplicableAreas(data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  fetchAllProductApplicableAreas(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .fetchAllHttpApplicableAreas(data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  saveProductData(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .saveHttpProduct(data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  saveNewApplicableArea(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .saveHttpApplicableArea(data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  updateProductDetails(_context,data){
        return new Promise((resolve,reject)=>{
          jwt
            .updateHttpProductDetail(data)
            .then((res) => {
            resolve(res);
          }).catch(err =>{
            reject(err);
          });
    });

      },
  updateApplicableAreaDetail(_context,data){
    return new Promise((resolve,reject)=>{
      jwt
        .updateHttpApplicableArea(data)
        .then((res) => {
          resolve(res);
        }).catch(err =>{
        reject(err);
      });
    });

  },
  deleteProductServer(_context,id){
    return new Promise((resolve, reject) => {
      jwt
        .deleteHttpProduct(id)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  deleteApplicableAreaServer(_context,id){
    return new Promise((resolve, reject) => {
      jwt
        .deleteHttpApplicableArea(id)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  fetchProductDetail(_context,id) {
    return new Promise((resolve, reject) => {
      jwt
        .fetchHttpProductDetail(id)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  fetchApplicableAreaDetail(_context,id) {
    return new Promise((resolve, reject) => {
      jwt
        .fetchHttpApplicableAreaDetail(id)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  fetchAllProductslist() {
    return new Promise((resolve, reject) => {
      jwt
        .fetchAllProducts()
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  createCustomProduct(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v2/products/create-custom-product', data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchProductDetailsV2(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/v2/products/${data.id}`, { params: data })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchProductsV2(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/v2/products/list/${data.organizationId}`, 
          { params: data }
        )
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  saveNewCustomApplicableArea(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v2/products/create-custom-applicable-area', data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchAllProductApplicableAreasV2(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v2/products/all-applicable-areas', { params: data })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  updateCustomProduct(_context,data){
    return new Promise((resolve,reject)=>{
      axios
        .patch(`/api/v2/products/${data.id}/update`, data.body)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  updateCustomApplicableArea(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/v2/products/${data.id}/update-custom-applicable-area`, data.payload)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  deleteCustomApplicableArea(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/v2/products/${data.id}/delete-custom-applicable-area`, { data: data.payload })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  assignCustomTreatmentAreas(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/v2/products/${data.id}/assign-custom-treatment-area`, data.payload)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
};
